import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import MobileMenu from "./MobileMenu";
import { NAV_ITEMS, PHONE_NUMBER, PHONE_TEL } from "./navigation";
import { scrollToTop } from "./ScrollToTop";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const desktopItems = NAV_ITEMS.slice(0, 4);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
          scrolled ? "bg-white/95 backdrop-blur-md border-b border-background-200" : "bg-transparent"
        }`}
      >
        <div className="w-full px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
          <Logo />

          {/* 데스크톱 메뉴 */}
          <nav className="hidden md:flex items-center gap-8">
            {desktopItems.map((item) => {
              const active = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={scrollToTop}
                  className={`relative text-[15px] font-medium whitespace-nowrap transition-colors cursor-pointer text-foreground-700 hover:text-primary-600 ${active ? "text-primary-600" : ""}`}
                >
                  {item.label}
                  {active && (
                    <span className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-primary-500" />
                  )}
                </Link>
              );
            })}
          </nav>

          <div className="flex items-center gap-3 md:gap-4">
            {/* 전화번호 */}
            <a
              href={PHONE_TEL}
              className="hidden sm:flex items-center gap-2 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer text-foreground-800"
            >
              <span className="w-8 h-8 rounded-full flex items-center justify-center bg-primary-100/70">
                <i className="ri-phone-line text-primary-600 text-base"></i>
              </span>
              <span className="font-semibold">{PHONE_NUMBER}</span>
            </a>

            {/* 예약 상담 버튼 */}
            <Link
              to="/reservation"
              className="hidden md:inline-flex items-center px-5 py-2.5 rounded-full bg-primary-500 text-white text-sm font-semibold whitespace-nowrap transition-all hover:bg-primary-600 cursor-pointer"
            >
              예약상담
            </Link>

            {/* 모바일 전화 + 햄버거 */}
            <a href={PHONE_TEL} className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer">
              <i className="ri-phone-line text-lg text-foreground-900"></i>
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen(true)}
              className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
              aria-label="메뉴 열기"
            >
              <i className="ri-menu-line text-2xl text-foreground-900"></i>
            </button>
          </div>
        </div>
      </header>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}